import { MenuButton, MenuItem } from '@szhsin/react-menu';
import styled, { css } from 'styled-components';

import { mediaQuery } from '../../../styles/mixin';
import { Clickable } from '../../Clickable';
import { Text } from '../../Typography/Text';

export const Container = styled.div`
    padding: 2rem 1rem;
    ${mediaQuery(
        2,
        css`
            width: 100vw;
            display: flex;
            flex-direction: row;
            padding: 1.25rem 0 0 1.25rem;
        `
    )}
`;

export const NavigationContainer = styled.div`
    position: fixed;
    top: 0;
    bottom: 0;
    z-index: 3;
    ${mediaQuery(
        2,
        css`
            min-height: 100vh;
            position: static;
            padding: 0 0 1.7rem;
        `
    )}
`;

export const NavigationBackground = styled.div`
    z-index: 2;
    content: ' ';
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(22, 37, 57, 0.3);
`;

export const Header = styled.header`
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0rem;
    ${mediaQuery(
        2,
        css`
            width: 100%;
            left: 0;
            padding-right: 2.375rem;
            justify-content: flex-end;
        `
    )}

    .szh-menu-container {
        position: absolute;
    }
`;

export const HeaderRightContainer = styled.div`
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    column-gap: 1rem;
    ${mediaQuery(
        2,
        css`
            column-gap: 1.375rem;
        `
    )}
`;

export const MainContentContainer = styled.div`
    width: 100%;
`;

export const Main = styled.main``;

export const MenuOpener = styled(Clickable)`
    height: 1.5rem;
    width: 1.5rem;
    ${mediaQuery(
        2,
        css`
            display: none;
        `
    )};
`;

export const StyledMenuButton = styled(MenuButton)`
    margin: 0;
    border: none;
`;

export const StyledMenuItem = styled(MenuItem)`
    justify-content: flex-start;
    padding-right: 4rem;
    padding-left: 1rem;

    ${Text} {
        margin-left: 0.75rem;
        font-size: ${({ theme }) => theme.fontSizes[5]};
        font-weight: 400;
    }

    & > svg {
        width: 1.375rem;
        margin: 0;
    }
`;
